import { useState } from "react";
import { useLang } from "../../context/LanguageContext";

export const Blueprints = () => {
  const { t } = useLang();
  const [active, setActive] = useState(0);
  const current = t.blueprints.items[active];

  return (
    <section id="blueprints" data-testid="blueprints-section" className="py-24 lg:py-32 border-b border-[#0B1F3A]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-6 mb-12">
          <div className="col-span-12 lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#D4AF37]" />
              <span className="overline">{t.blueprints.eyebrow}</span>
            </div>
            <h2 className="font-display text-3xl lg:text-4xl font-light text-[#0B1F3A] leading-tight">
              {t.blueprints.title}
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-[#0B1F3A]/70 text-base lg:text-lg leading-relaxed">{t.blueprints.sub}</p>
          </div>
        </div>

        <div className="grid grid-cols-12 border border-[#0B1F3A]/15 bg-white">
          {/* sidebar */}
          <aside className="col-span-12 lg:col-span-4 border-r border-[#0B1F3A]/15 bg-[#F8F9FA]">
            {t.blueprints.items.map((b, i) => (
              <button
                key={b.id}
                data-testid={`blueprint-tab-${b.id}`}
                onClick={() => setActive(i)}
                className={`w-full text-left px-6 py-5 border-b border-[#0B1F3A]/10 transition-colors relative ${
                  i === active ? "bg-white" : "hover:bg-white/60"
                }`}
              >
                {i === active && <span className="absolute left-0 top-0 bottom-0 w-0.5 bg-[#D4AF37]" />}
                <div className="text-[10px] uppercase tracking-[0.18em] text-[#0B1F3A]/50 font-semibold mb-2">
                  {t.blueprints.label} · {String(i + 1).padStart(2, "0")}
                </div>
                <div className="font-display text-[15px] font-semibold text-[#0B1F3A] leading-snug">
                  {b.name}
                </div>
              </button>
            ))}
          </aside>

          {/* content */}
          <div className="col-span-12 lg:col-span-8 p-8 lg:p-10" data-testid={`blueprint-content-${current.id}`}>
            <div className="flex items-center justify-between mb-6 pb-4 border-b border-[#0B1F3A]/10">
              <span className="overline">{t.blueprints.label}</span>
              <span className="text-[10px] tracking-widest text-[#0B1F3A]/40 font-mono">REF-{String(active + 1).padStart(3, "0")}</span>
            </div>
            <h3 className="font-display text-2xl lg:text-3xl text-[#0B1F3A] font-light">{current.name}</h3>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
              <Block title={t.blueprints.challenge} body={current.challenge} />
              <Block title={t.blueprints.arch} body={current.architecture} />
              <Block title={t.blueprints.flow} body={current.workflow} mono />
              <div className="border border-[#0B1F3A]/15 p-5">
                <div className="overline mb-3">{t.blueprints.out}</div>
                <ul className="space-y-2 text-sm text-[#0B1F3A]/80">
                  {current.outcomes.map((o) => (
                    <li key={o} className="flex gap-2">
                      <span className="text-[#D4AF37]">→</span>
                      <span>{o}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Block = ({ title, body, mono }) => (
  <div className="border border-[#0B1F3A]/15 p-5">
    <div className="overline mb-3">{title}</div>
    <p className={`text-sm leading-relaxed text-[#0B1F3A]/80 ${mono ? "font-mono text-[12px]" : ""}`}>{body}</p>
  </div>
);
